import { useRuntimeThemeLifecycle } from '@emporion/ui'
import {
  applyThemeToDocument,
  fetchPublicRuntimeTheme,
  getDefaultRuntimeTheme,
  readCachedRuntimeTheme,
} from './runtime'

export const useAdminThemeRuntime = () =>
  useRuntimeThemeLifecycle({
    readCachedTheme: readCachedRuntimeTheme,
    applyTheme: applyThemeToDocument,
    fetchTheme: fetchPublicRuntimeTheme,
    getFallbackTheme: getDefaultRuntimeTheme,
  })
